/**
 * Polyfills for legacy browsers (studio iPad on iOS 12 / Safari 12.1).
 * MUST be the first import in index.js — runs before any app module.
 * Each polyfill is guarded and only applies when the native API is missing.
 */
import { ResizeObserver as ResizeObserverPonyfill } from "@juggle/resize-observer";

if (typeof window !== "undefined") {
  if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserverPonyfill;
  }

  if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (search, replacement) {
      const target = String(this);
      if (search instanceof RegExp) {
        if (!search.global) throw new TypeError("replaceAll must be called with a global RegExp");
        return target.replace(search, replacement);
      }
      return target.split(String(search)).join(String(replacement));
    };
  }

  if (!Promise.allSettled) {
    Promise.allSettled = function (promises) {
      return Promise.all(
        Array.from(promises, (p) =>
          Promise.resolve(p).then(
            (value) => ({ status: "fulfilled", value }),
            (reason) => ({ status: "rejected", reason })
          )
        )
      );
    };
  }

  if (!Array.prototype.at) {
    Array.prototype.at = function (n) {
      const len = this.length >>> 0;
      let i = Math.trunc(n) || 0;
      if (i < 0) i += len;
      return i >= 0 && i < len ? this[i] : undefined;
    };
  }

  if (!Array.prototype.findLast) {
    Array.prototype.findLast = function (fn, thisArg) {
      for (let i = this.length - 1; i >= 0; i--) {
        if (fn.call(thisArg, this[i], i, this)) return this[i];
      }
      return undefined;
    };
  }

  if (!Array.prototype.findLastIndex) {
    Array.prototype.findLastIndex = function (fn, thisArg) {
      for (let i = this.length - 1; i >= 0; i--) {
        if (fn.call(thisArg, this[i], i, this)) return i;
      }
      return -1;
    };
  }

  if (!Object.hasOwn) {
    Object.hasOwn = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(Object(obj), prop);
    };
  }
}
